/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

/**
 * Custom react portal component
 * use to mount any modal component
 * inside the player module
 */
const PlayerModal = ({ children, container }) =>
  ReactDOM.createPortal(children, container);

PlayerModal.displayName = 'PlayerModal';

PlayerModal.propTypes = {
  /**
   * Container where portals are created
   * */
  container: PropTypes.object.isRequired,
  /**
   * React any type of child
   * */
  children: PropTypes.any.isRequired,
};

export default PlayerModal;
